/**
 * Product Gallery Navigation (Buttons Only)
 * Disables swipe/touch controls for mobile, keeping only button navigation
 * Works alongside the existing slider component without interfering
 */

class ProductGalleryButtonOnlyNavigation {
  constructor() {
    this.init();
  }

  init() {
    // Only apply on mobile devices
    if (window.innerWidth >= 750) return;

    // Find all media galleries on the page
    const mediaGalleries = document.querySelectorAll('media-gallery');
    
    mediaGalleries.forEach(gallery => {
      this.setupButtonOnlyNavigation(gallery);
    });
  }

  setupButtonOnlyNavigation(gallery) {
    const slider = gallery.querySelector('slider-component');
    const mediaList = gallery.querySelector('.product__media-list');
    
    if (!slider || !mediaList) return;

    // Disable touch/swipe interactions on the media list container
    this.disableTouchInteractions(mediaList);
  }

  disableTouchInteractions(container) {
    // Prevent touch events from interfering with button navigation
    // This ensures only the navigation buttons work, not swipe gestures
    
    // Add CSS to prevent touch scrolling on the media list
    container.style.touchAction = 'none';
    container.style.userSelect = 'none';
    
    // Prevent default touch behaviors that could interfere with button clicks
    container.addEventListener('touchstart', (e) => {
      // Allow touch events to bubble up for button clicks
      // but prevent any swipe-like behavior
      e.stopPropagation();
    }, { passive: false });
    
    container.addEventListener('touchmove', (e) => {
      // Prevent any touch movement from causing scrolling or swiping
      e.preventDefault();
    }, { passive: false });
    
    container.addEventListener('touchend', (e) => {
      // Allow touch end events for button clicks
      e.stopPropagation();
    }, { passive: false });
  }

  // Navigation buttons are handled by the existing slider component
  // No additional navigation logic needed since we're disabling swipe
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ProductGalleryButtonOnlyNavigation();
});

// Re-initialize on window resize to handle orientation changes
window.addEventListener('resize', debounce(() => {
  new ProductGalleryButtonOnlyNavigation();
}, 250));

// Debounce function (reuse from global.js if available, otherwise define here)
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}